// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";

Vue.config.productionTip = false;
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/public.css";
import * as echarts from "echarts";
import AMap from 'vue-amap';


Vue.prototype.$echarts = echarts;
Vue.use(ElementUI);
Vue.use(AMap);

// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: 'a29c2f389334d6505816073c1bac10b6',  //注意这里引入你在高德申请的key值
  // 插件集合 （插件按需引入）
  plugin: [
    'AMap.Geolocation',
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor'

  ],
  v: '1.4.4'
});

window._AMapSecurityConfig = {
  securityJsCode: "b59c36bfaf9a73ac515cc34d1f61ac7d"
};
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js